import { matchRoutes } from 'react-router-dom'

/**
 * SOLY-SUPPLIER-002 MS-05 — pages that receive Microsoft's answer for people outside Soly (a
 * customer's Microsoft administrator): no Hotjar, no Canny there. Matched the way <Routes> matches
 * (case-insensitive, percent-decoded), so no alias of the page renders with the trackers on.
 */
const UNTRACKED_ROUTES = [{ path: '/microsoft/*' }]

export function isUntrackedPath(pathname: string): boolean {
  return matchRoutes(UNTRACKED_ROUTES, pathname) !== null
}
